import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BrokenImageLinkTest } from '../../../components/BrokenImageLinkTest';
import { Hyperlink } from '../../../components/Hyperlink';
import { fetchProfessionalInfos } from '../../../lawyer/lawyer.api';
import { LawyerNamePlaceholder } from '../LawyerNamePlaceholder';

type Props = {
  pictureUrl: string;
  href: string;
  name: string;
};

type State = {
  firstname: string;
  lastname: string;
  loading: boolean;
};

export class NavLawyerProfile extends React.Component<Props, State> {
  state: State = {
    firstname: '',
    lastname: '',
    loading: true,
  };

  async componentDidMount() {
    const { name } = this.props;
    if (!name)
      try {
        const { firstname, lastname } = await fetchProfessionalInfos();
        this.setState({ firstname, lastname, loading: false });
      } catch (err) {
        throw err;
      }
    else
      this.setState({
        firstname: name,
        lastname: '',
        loading: false,
      });
  }

  render() {
    const { href, pictureUrl } = this.props;
    const { firstname, lastname, loading } = this.state;
    const lawyerName = `${firstname} ${lastname}`;

    return (
      <Hyperlink href={href} className="nav-lawyer-profile">
        <BrokenImageLinkTest url={pictureUrl}>
          {(isImageLinkBroken: boolean) => (
            <img
              className="nav-lawyer-profile__picture"
              src={
                pictureUrl && !isImageLinkBroken
                  ? pictureUrl
                  : '/img/user/user_icon.png'
              }
              alt={lawyerName}
            />
          )}
        </BrokenImageLinkTest>
        <div className="nav-lawyer-profile__name-container">
          {!loading ? (
            <div
              className="nav-lawyer-profile__title"
              data-test-id="nav-user-name"
            >
              {lawyerName}
            </div>
          ) : (
            <LawyerNamePlaceholder />
          )}
          <div className="nav-lawyer-profile__subtitle">
            <FormattedMessage id="navigation/user/components/NavLawyerProfile.tsx/1" />
          </div>
        </div>
      </Hyperlink>
    );
  }
}
